import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

// COMPONENTS
import Footer from '../../components/Footer';
import Row from '../../components/Row';
import { Typography, Column, Container } from 'components';

import viewportHoc from '../../hoc/viewportHoc';
import * as actions from '../../redux/actions';

class ConnectionError extends Component {
  componentDidMount() {
    const failedData = {
      isAuth: false,
      profilePermissions: null,
      failMessage: "",
      profileSelected: null,
      userData: null,
      userToken: null,
    };

    this.props.clearAuth(failedData.failMessage);
  }

  render() {
    return (
      <Fragment>
        <div className='ConnectionError'>
          <Container>
            <Column colWidth={9}>
              <Row align='center' justify='center' padding='20% 0% 43% 30%'>
                <Typography align='center' Tag='h1' type='title'>
                  A página não pode ser carregada.
                </Typography>
              </Row>
            </Column>
          </Container>
        </div>
        <Footer isMobile={this.props.isMobile} />
      </Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({ clearAuth: (failedData) => dispatch(actions.authFailed(failedData)) });

export default connect(null, mapDispatchToProps)(viewportHoc(ConnectionError));